import validate from "/opt/build/repo/node_modules/nuxt/dist/pages/runtime/validate.js";
import route_45redirect_45global from "/opt/build/repo/client/middleware/route-redirect.global.js";
import secondary_45navigation_45global from "/opt/build/repo/client/middleware/secondary-navigation.global.js";
import manifest_45route_45rule from "/opt/build/repo/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  route_45redirect_45global,
  secondary_45navigation_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "authenticated-client": () => import("/opt/build/repo/client/middleware/authenticated.client.js")
}